export class Member {
  subUserId: number;
  firstName: string;
  lastName: string;
  userName: string;
  password: string;
  email: string;
  universityId: string;
  photoId!: number;
}
